import '@common/sentry';

import App from '@common-pages/App';
import { bootstrap } from './bootstrap';

const isPublicStandaloneRoute = /^\/(keyboard-shortcuts)\/?$/.test(
  window.location.pathname
);

if (isPublicStandaloneRoute) {
  // Standalone routes don't need aiWARE — bootstrap immediately instead of
  // idling on the 500ms polling interval.
  bootstrap(<App appName="redact" />, 'root');
} else {
  let aiware_init_time = 0;
  const loadingInterval = window.setInterval(() => {
    aiware_init_time += 1;
    if (window.aiware || aiware_init_time > 10) {
      if (aiware_init_time > 10) {
        console.error("AIWare didn't initialize in time - skipping");
      }
      window.clearInterval(loadingInterval);
      bootstrap(<App appName="redact" />, 'root');
    }
  }, 500);
}
